import {Component, Input} from '@angular/core';
import {Proposal} from '../../../model/proposal/proposal';

@Component({
    selector: 'app-insurance-contract-detail-risk-description',
    templateUrl: './insurance-contract-detail-risk-description.component.html',
    standalone: false
})
export class InsuranceContractDetailRiskDescriptionComponent {
  @Input() proposal: Proposal;

}
